import React, { useState } from "react";
import './apiDebug.css';

export default function DataCronDebug({ data }) {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <>
      {data ? (
        <div className="api-data-viewer w-100">
          <div className="container w-100" style={{backgroundColor: '#014788'}}>
            <h2 style={{color: '#FFFFFF', textAlign: 'center', padding: '5px 0'}}>Detalle de Process Monitor</h2>
          </div>
          
          {/* Sección de Información Básica */}
          <div className="section">
            <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e2cc'}}>
              <h3 className='m-0'>Información Básica</h3>
              <span onClick={() => toggleSection('basicInfo')} style={{fontSize: 17}}>
                {expandedSections?.basicInfo ? '▼' : '▶'}
              </span>
            </div>
            {expandedSections?.basicInfo && (
              <div className="basic-info" style={{padding: '25px 45px'}}>
                <div className="detail-row">
                  <span className="detail-label">ID:</span>
                  <span className="detail-value">{data._id}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Code:</span>
                  <span className="detail-value">{data.code}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">active:</span>
                  <span className={`status-value ${data.active ? 'active' : 'inactive'}`}>
                    {data.active ? 'Activo' : 'Inactivo'}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Progreso | Advance:</span>
                  <span className="detail-value">{data.advance}% completado</span>
                </div>
              </div>
            )}
          </div>

          {/* Sección de Descripción */}
          <div className="section">
            <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e242'}}>
              <h3 className='m-0'>Descripción | Tasks</h3>
              <span onClick={() => toggleSection('description')} style={{fontSize: 17}}>
                {expandedSections?.description ? '▼' : '▶'}
              </span>
            </div>
            {expandedSections?.description && (
              <div className="description-info" style={{padding: '25px 45px'}}>
                <p>
                  {data.name[0]
                    .replace('%s', data.name[1])
                    .replace('%s', data.name[2])}
                </p>
              </div>
            )}
          </div>

          {/* Sección de Tiempos */}
          <div className="section">
            <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e2cc'}}>
              <h3 className='m-0'>Tiempos</h3>
              <span onClick={() => toggleSection('times')} style={{fontSize: 17}}>
                {expandedSections?.times ? '▼' : '▶'}
              </span>
            </div>
            {expandedSections?.times && (
              <div className="times-info" style={{padding: '25px 45px'}}>
                <div className="detail-row">
                  <span className="detail-label">Creado:</span>
                  <span className="detail-value">
                    {new Date(data.createdAt).toLocaleString()}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Actualizado:</span>
                  <span className="detail-value">
                    {new Date(data.updatedAt).toLocaleString()}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Sección de Tareas */}
          <div className="section">
            <div className="container d-flex align-items-center" style={{gap: 6, padding:'12px 16px', backgroundColor: '#e2e2e242'}}>
              <h3 className='m-0'>Tareas</h3>
              <span onClick={() => toggleSection('tasks')} style={{fontSize: 17}}>
                {expandedSections?.tasks ? '▼' : '▶'}
              </span>
            </div>
            {expandedSections?.tasks && (
              <div className="tasks-info" style={{padding: '25px 45px'}}>
                <div className="detail-row">
                  <span className="detail-label">Tarea actual:</span>
                  <span className="detail-value">
                    {data.tasks[data.currentTask]}
                  </span>
                </div>
                <pre>{JSON.stringify(data.tasks, null, 2)}</pre>
              </div>
            )}
          </div>
        </div>
      ) : (
        <p>No hay datos disponibles</p>
      )}
    </>
  );
}